import { render, staticRenderFns } from "./TheFaq.vue?vue&type=template&id=52a7c7fd&scoped=true"
import script from "./TheFaq.vue?vue&type=script&lang=js"
export * from "./TheFaq.vue?vue&type=script&lang=js"
import style0 from "./TheFaq.vue?vue&type=style&index=0&id=52a7c7fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a7c7fd",
  null
  
)

export default component.exports